import type { DagColumnMeta } from '@/types/dag'

export const HIDDEN_ATTRIBUTE_IDS = new Set([
  'store_model_id',
  'workflow_status',
  'annual_units_per_store',
  'avg_units_per_week',
  'is_new_sku',
  'like_sku_auc',
  'like_sku_aur',
  'like_sku_discount_rate',
  'like_sku_fob',
  'like_sku_gross_margin_pct',
  'like_sku_imu_pct',
  'like_sku_num_weeks',
  'like_sku_retail',
  'like_sku_sales_dollars',
  'like_sku_sales_units',
  'like_sku_store_count',
  'like_sku_units_per_store_year',
])

export const NON_CONFIGURABLE_COLUMN_IDS = new Set([
  'description',
  'plan_sku_num',
])

export const FIXED_ATTRIBUTE_IDS = new Set([
  'custom_attr:sells_like_seasonal',
  'custom_attr:trend',
  'custom_attr:quality_level',
  'custom_attr:material',
  'custom_attr:lifestyle',
  'custom_attr:exclusive_design',
  'custom_attr:item_type',
])

export function isFixedAttribute(column: DagColumnMeta): boolean {
  return FIXED_ATTRIBUTE_IDS.has(column.id)
}

export function getConfigurableColumns(columns: DagColumnMeta[]) {
  return columns.filter(
    column =>
      column.kind !== 'aggregate' &&
      !NON_CONFIGURABLE_COLUMN_IDS.has(column.id) &&
      !HIDDEN_ATTRIBUTE_IDS.has(column.id) &&
      column.group !== 'Identity'
  )
}

export function getDefaultHiddenColumnIds(
  columns: DagColumnMeta[],
  primaryAttributes: string[]
) {
  const primarySet = new Set(primaryAttributes)

  return columns
    .filter(
      column =>
        !NON_CONFIGURABLE_COLUMN_IDS.has(column.id) &&
        !HIDDEN_ATTRIBUTE_IDS.has(column.id) &&
        column.group !== 'Identity' &&
        !FIXED_ATTRIBUTE_IDS.has(column.id) &&
        !primarySet.has(column.id)
    )
    .map(column => column.id)
}

export function getSecondaryColumns(
  columns: DagColumnMeta[],
  primaryAttributes: string[]
) {
  const primarySet = new Set(primaryAttributes)
  return columns.filter(
    col =>
      !NON_CONFIGURABLE_COLUMN_IDS.has(col.id) &&
      !HIDDEN_ATTRIBUTE_IDS.has(col.id) &&
      col.group !== 'Identity' &&
      !FIXED_ATTRIBUTE_IDS.has(col.id) &&
      !primarySet.has(col.id)
  )
}
